export default __webpack_public_path__ + "static/media/P941_RoHS.636ff172.pdf";